import { defineComponent as _defineComponent } from 'vue'
import { ref, unref, watch } from 'vue';
import { CardManagerType, CardManager } from '../scripts/types';
import { searchCardManagers } from '../scripts/cardApiRequests';
import { debounce, isEmpty } from "@/scripts/Common/HelperFunctions";
import { isWholeNumber } from "@/scripts/Common/validators/defaultValidator";
import { CardStates } from "@/Enums";
import { useI18n } from "@/composables/useI18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFilter',
  emits: [
  'onSearchFilter',
],
  setup(__props, { emit: emits }) {

const { t } = useI18n();



const selectedState = ref<CardStates | undefined>();
const cardNumber = ref<string | undefined | null>();
const stateItems = [
  { text: t('card_state_assigned'), state: CardStates.Assigned },
  { text: t('card_state_unassigned'), state: CardStates.Unassigned },
  { text: t('card_state_unknown'), state: CardStates.Unknown },
];

const selectedTypes = ref<CardManagerType[]>([]);
const selectedManager = ref<CardManager | string | null>(null);
const managerSearchInput = ref<string | null>('');
const managers = ref<CardManager[]>([]);
const loadingManagers = ref(false);

const typeItems = [
  /**
   * TODO: Customer and Operator is not implemented in the API yet but will be implemented in the future.
   * Uncomment the lines below when the API is ready. No other changes are needed.
   */
  // { text: t('card_manager_type_operator'), type: CardManagerType.Operator },
  { text: t('card_manager_type_issuer'), type: CardManagerType.Issuer },
  // { text: t('card_manager_type_customer'), type: CardManagerType.Customer },
];

const onHandleChange = () => {
  emits('onSearchFilter', {
    cardState: unref(selectedState),
    cardNumber: typeof cardNumber.value === "string" && cardNumber.value !== ""
      ? Number.parseInt(unref(cardNumber)!)
      : undefined,
    managerTypes: selectedTypes.value,
    managerName: typeof selectedManager.value === 'object' && selectedManager.value !== null
      ? selectedManager.value.name
      : undefined
  });
};

const onHandleClearCardState = () => {
  selectedState.value = undefined;
  onHandleChange();
};

const onHandleClearTypes = () => {
  selectedTypes.value = [];
  selectedManager.value = null;
  onHandleChange();
};

const onHandleClearManager = () => {
  selectedManager.value = null;
  onHandleChange();
};

const loadManagers = async () => {
  if (!selectedTypes.value.length || !managerSearchInput.value) {
    managers.value = [];
    return;
  }

  loadingManagers.value = true;
  try {
    managers.value = (await searchCardManagers(selectedTypes.value, managerSearchInput.value))
                      .sort((a, b) => a.name.localeCompare(b.name));;
  } finally {
    loadingManagers.value = false;
  }
};

watch(() => cardNumber.value, debounce(() => {
  if (isEmpty(cardNumber.value) || isWholeNumber(cardNumber.value)) {
    onHandleChange()
  }
}));

watch(selectedState, () => {
  onHandleChange()
});

watch(() => managerSearchInput.value, debounce(loadManagers));

watch(selectedTypes, () => {
  if (!selectedTypes.value.length) {
    selectedManager.value = null;
  }
  onHandleChange();
});

watch(() => selectedManager.value, () => {
  onHandleChange();
});

return { __sfc: true,t, emits, selectedState, cardNumber, stateItems, selectedTypes, selectedManager, managerSearchInput, managers, loadingManagers, typeItems, onHandleChange, onHandleClearCardState, onHandleClearTypes, onHandleClearManager, loadManagers }
}

})